var _style, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatternSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 194,
    viewBox: "0 0 1440 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\r\n    /* Define the Bootstrap primary color variable */\r\n    :root {\r\n      --bs-primary: #8b3dff; /* Change this to your desired Bootstrap primary color */\r\n    }\r\n  ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 129.041,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 64.7705,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 196.725,
    y: 129.041,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 196.725,
    y: 64.7705,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 196.725,
    y: 0.5,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 392.95,
    y: 129.041,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 392.95,
    y: 64.7705,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 392.95,
    y: 0.5,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 589.176,
    y: 129.041,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 589.176,
    y: 64.7705,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 589.176,
    y: 0.5,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 785.401,
    y: 129.041,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 785.401,
    y: 64.7705,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 785.401,
    y: 0.5,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 981.626,
    y: 129.041,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 981.626,
    y: 64.7705,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 981.626,
    y: 0.5,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 1177.85,
    y: 129.041,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 1177.85,
    y: 64.7705,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 1177.85,
    y: 0.5,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 65.9082,
    y: 129.041,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 65.9082,
    y: 64.7705,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 65.9082,
    y: 0.5,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 262.134,
    y: 129.041,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 262.134,
    y: 64.7705,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 262.134,
    y: 0.5,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 458.359,
    y: 129.041,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 458.359,
    y: 64.7705,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 458.359,
    y: 0.5,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 654.584,
    y: 129.041,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 654.584,
    y: 64.7705,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 654.584,
    y: 0.5,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 850.81,
    y: 129.041,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 850.81,
    y: 64.7705,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 850.81,
    y: 0.5,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 1047.03,
    y: 129.041,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 1047.03,
    y: 64.7705,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 1047.03,
    y: 0.5,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 1243.26,
    y: 129.041,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 1243.26,
    y: 64.7705,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 1243.26,
    y: 0.5,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 131.317,
    y: 129.041,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 131.317,
    y: 64.7705,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 131.317,
    y: 0.5,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 327.542,
    y: 129.041,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 327.542,
    y: 64.7705,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 327.542,
    y: 0.5,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 523.768,
    y: 129.041,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 523.768,
    y: 64.7705,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 523.768,
    y: 0.5,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 719.992,
    y: 129.041,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 719.992,
    y: 64.7705,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 719.992,
    y: 0.5,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 916.219,
    y: 129.041,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 916.219,
    y: 64.7705,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 916.219,
    y: 0.5,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 1112.44,
    y: 129.041,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 1112.44,
    y: 64.7705,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 1112.44,
    y: 0.5,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 1308.67,
    y: 129.041,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 1374.08,
    y: 129.041,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 1308.67,
    y: 64.7705,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 1374.08,
    y: 64.7705,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 1308.67,
    y: 0.5,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 1374.08,
    y: 0.5,
    width: 66,
    height: 64.2854,
    stroke: "var(--bs-primary)",
    strokeOpacity: 0.09
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternSquare);
export default __webpack_public_path__ + "static/media/pattern-square.a6146f973a1be5ceed06ec2b826beaeb.svg";
export { ForwardRef as ReactComponent };